module.exports = __webpack_public_path__ + "img/prop-comp.7355b438.png";